import AdvancedSearchLink from "./AdvancedSearchLink";

export default AdvancedSearchLink;
